import { set } from 'mobx';
import React, { useEffect } from 'react' 

const CopyLinkIcon = () => {
    const [copied, setCopied] = React.useState(false)

    const handleClick = () => {
        setCopied(true);
        navigator.clipboard.writeText(window.location.href)
          .then(() => {
            // console.log('URL copied to clipboard successfully!');
          })
          .catch(err => {
            console.log('Failed to copy URL: ', err);
          });

        setTimeout(() => {
            setCopied(false)
        }, 300)
      };

    return (
        <div className={copied ? 'flex--center copied' : 'flex--center'}onClick={handleClick}>
            <svg viewBox="0 0 24 24" fill="none" >
                <g id="Interface / Link">
                    <path id="Vector" d="M9.1718 14.8288L14.8287 9.17192M7.05086 11.293L5.63664 12.7072C4.07455 14.2693 4.07409 16.8022 5.63619 18.3643C7.19829 19.9264 9.7317 19.9259 11.2938 18.3638L12.7065 16.9498M11.2929 7.05L12.7071 5.63579C14.2692 4.07369 16.8016 4.07397 18.3637 5.63607C19.9258 7.19816 19.9257 9.73085 18.3636 11.2929L16.9501 12.7071" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
            </svg>
            <style jsx>{`
                div {
                    height: 50px;
                    width: 50px;
                    border-radius: 50%;
                    background: #dfdfdf;
                    cursor: pointer;
                    transition: all .2s ease;
                }
                .copied {
                    background: ${copied ? '#90E15B' : '#dfdfdf'};
                }
                path {
                    transition: all .2s ease;
                }
                .copied path {
                    stroke: #fff;

                }
                svg {
                    height: 32px;
                }
            `}</style>
        </div>
    )
}

export default CopyLinkIcon